module.exports = __webpack_public_path__ + "media/warranty-claim/photos-close-up-e75dd4ed.png";